function getDescricaoRecurso(rec) {
    switch(rec) {
        case 'ATUALIZACAO_BANCO':          return 'Atualização de Banco versaodb';
        case 'ATUALIZACAO_BANCO2':         return 'Atualização de Banco versaodb2';
        case 'ATUALIZACAO_BANCO_AURELIUS': return 'Atualização de Banco Aurelius';
        case 'ATUALIZACAO_PRECO':          return 'Atualização de Preço';
        case 'ATUALIZACAO_BANCO_DROP':     return 'Atualização de Drops do banco';
        case 'BACKUP':                     return 'Falha no Backup do Banco de Dados';
        case 'CONVENIO_WEB':               return 'Convênio Web';
        case 'DOWNLOAD_SEFAZ':             return 'Download de NFe da SEFAZ';
        case 'DOWNLOAD_UPDATE':            return 'Download de update do sistema';
        case 'EVENTO_TP':                  return 'Eventos ToolsPharma';
        case 'IBPTAX':                     return 'Download da tabela IBPTax';
        case 'INCONSISTENCIA_ESTOQUE':     return 'Verificação de inconsistência de estoque';
        case 'LICENCA':                    return 'Verificação de licença';
        case 'MENSAGEM_TP':                return 'Mensagens ToolsPharma';
        case 'MONITOR_DISCO_BANCO':        return 'Pouco espaço em disco para o banco de dados';
        case 'MONITOR_DISCO_WINDOWS':      return 'Espaço em disco do Windows';
        case 'MONITOR_MEMORIA':            return 'Alto consumo de memória RAM';
        case 'MONITOR_TRANSACOES_PRESAS':  return 'Transações presas';
        case 'OTIMIZACAO_BANCO':           return 'Otimização do banco de dados';
        case 'RECURSO_CLOUD':              return 'Envio de dados para o Google Firestore';
        case 'REQUISICAO_ESTOQUE':         return 'Processamento de requisições de movimento de estoque (transferências)';
        case 'VALIDADE_PONTOS':            return 'Atualização de pontos de fidelidade vencidos';
        case 'ATUALIZACAO_ARQUIVOS_TECNOSPEED': return 'Atualização de arquivos da NFS-e TecnoSpeed';
        case 'BUSCA_IP_SERVIDOR':          return 'Falha na busca do IP do servidor';
        case 'MONITOR_USUARIO_BANCO':      return 'Alerta de usuário com acesso ao banco de dados';
        case 'MONITOR_CONVENIO_WEB':       return 'Convênio Web'; 
        case 'MONITOR_BLOCOX_ESTOQUE':     return 'Bloco X estoque'; 
        case 'CLIMBA_COMMERCE_PEDIDO':     return 'Pedidos ecommerce climba';
        case 'IMPRESSAO_PICKLIST':         return 'Impressão Picklist';
        case 'REGISTROS_ALTERAR_ONLINE':   return 'Thread alterar registros';
        case 'MONITOR_TRIGGERS_SYMMETRIC':  return 'Monitor triggers symmetric';
        case 'MONITOR_DESLIGAMENTO_INCORRETO': return 'Desligamento incorreto';
        case 'MONITOR_CONFIGURACOES':      return 'Configurações';
        case 'MONITORES':                  return 'MONITORES';
        case 'PEDIDO_ONLINE_NAPP':         return 'Pedidos online NAPP';
        case 'ENVIO_NOTAS_CLOUD':         return 'Falha no Envio de notas para a nuvem';
        case 'NCM':                        return 'Erro na consulta NCM';
        case 'MONITOR_NOTAS_CLOUD':        return 'Envio de Notas Cloud';
        case 'ENVIO_DADOS_ANALYTICS':      return 'Envio de dados Analytics'
        case 'FUNCIONALCARD':              return 'FuncionalCard';
        default:                           return rec;
    }
};

export default getDescricaoRecurso;